import apiClient from "./api.client.service";
import {
  SubscriptionDto,
  upgradeSubscriptionDto,
} from "../Dto/Subscription.dto";
import { Status } from "../Entities/Subscription";

interface VerifyPaymentDto {
  razorpay_subscription_id: string;
  razorpay_payment_id: string;
  razorpay_signature: string;
}

class SubscriptionPurchaseService {
  private APIBaseUrl: string;

  constructor() {
    this.APIBaseUrl = process.env.REACT_APP_API_BASE_URL ?? "";
  }

  async buyNewSubscription(data: SubscriptionDto) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/admin/subscription`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "🚀 ~ SubscriptionPurchaseService ~ buySubscription ~ error:",
        error
      );
    }
  }

  async upgradeSubscription(data: upgradeSubscriptionDto) {
    try {
      const response = await apiClient.patch(
        `${this.APIBaseUrl}/admin/subscription`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error: any) {
      console.error(
        "🚀 ~ SubscriptionPurchaseService ~ upgradeSubscription ~ error:",
        error
      );
    }
  }

  async verifyPayment(data: VerifyPaymentDto) {
    try {
      const response = await apiClient.post(
        `${this.APIBaseUrl}/admin/subscription/verify-payment`,
        data,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (error: any) {
      console.error(
        "🚀 ~ SubscriptionPurchaseService ~ verifyPayment ~ error:",
        error
      );
    }
  }

  async verifySubscriptionStatus(
    subscriptionId: string,
    status: Status
  ): Promise<boolean> {
    try {
      const response = await apiClient.get(
        `${this.APIBaseUrl}/admin/subscription/check/${subscriptionId}?status=${status}`
      );
      return response.data;
    } catch (error) {
      console.error(
        "🚀 ~ SubscriptionClass ~ checkSubscriptionStatus ~ error:",
        error
      );
      return false;
    }
  }
}

const subscriptionPurchaseService = new SubscriptionPurchaseService();

export default subscriptionPurchaseService;
